export function getStaticPrefix(benderPackage, injectedBenderDeps) {
  // Accessing window.hubspot.bender directly is necessary so that
  // we don't end up with a blocking module in apps that don't incorporate
  // the mixin
  const benderDeps = injectedBenderDeps || window.hubspot && window.hubspot.bender || {};
  const {
    staticDomainPrefix,
    depVersions,
    depPathPrefixes
  } = benderDeps;
  if (!staticDomainPrefix || !depVersions || !depPathPrefixes) {
    return '';
  }
  let prefix = staticDomainPrefix;

  // So that the URL can be requested when the app are run locally via asset-bender,
  // we override the domain to use the CDN instead of the local domain
  if (staticDomainPrefix === '//local.hsappstatic.net') {
    if (depVersions[benderPackage] !== 'static') {
      prefix = '//static.hsappstatic.net';
    }
  }
  if (!depPathPrefixes[benderPackage]) {
    console.error('Bender package %s is missing from static_conf.json', benderPackage);
    return '';
  }
  return `${prefix}${depPathPrefixes[benderPackage]}`;
}
export function getStaticUrl(benderPackage, path, injectedBenderDeps) {
  return `${getStaticPrefix(benderPackage, injectedBenderDeps)}${path}`;
}